/**
 * Enum for all module names used in RouteErrorBoundary within the Admin app.
 */
export enum ModuleName {
  // ─── Auth ──────────────────────────────────────────────────────────────────
  Login = "Login",
  ForgotPassword = "ForgotPassword",
  OtpVerification = "OtpVerification",
  CheckEmailInstruction = "CheckEmailInstruction",
  ResetPassword = "ResetPassword",

  // ─── Private ───────────────────────────────────────────────────────────────
  Dashboard = "Dashboard",
  AdminAccount = "AdminAccount",
  CommissionRules = "CommissionRules",
  AddEditCommissionRules = "AddEditCommissionRules",
  Target = "Target",
  AddEditTarget = "AddEditTarget",
  Partner = "Partner",
  AddEditPartner = "AddEditPartner",
  ViewPartner = "ViewPartner",
  ViewMappedUser = "ViewMappedUser",
  RunPayout = "RunPayout",
  PayoutLog = "PayoutLog",
  SettingPage = "SettingPage",
  MessageCreditConfiguration = "MessageCreditConfiguration",
  TenantSubscription = "TenantSubscription",
  Coupon = "Coupon",
  AddEditCoupon = "AddEditCoupon",
  ModelWiseConfiguration = "ModelWiseConfiguration",
  ModelWiseConfigForm = "ModelWiseConfigForm",
}
